import { useLabels } from '../../i18n/labels';
import { STAGE_PILL_CLS } from '../../utils/tournament';
import { BADGE_XS, BADGE_XXS } from '../shared/badgeSize';

/** The sizes in use: the default, a dense table (10 px), and the print list (9 px). */
const SIZE = {
  sm: '',
  xs: `${BADGE_XS} px-1`,
  print: `${BADGE_XXS} px-1`,
} as const;

/** The stage of a bout as a pill: the colour of `STAGE_PILL_CLS` (Final amber,
 *  SF purple, QF blue, any other stage grey) and the text of `stageLabel()`.
 *  A bout with no stage has no pill (#458, #661). The live rows of the
 *  tournament card and of the Overview tab keep their own markup: they draw no
 *  pill for an unmapped stage, and their grid depends on it. */
export default function StagePill({ stage, size = 'sm', className = '' }: {
  stage: string | null | undefined;
  size?: keyof typeof SIZE;
  className?: string;
}) {
  const { stageLabel } = useLabels();
  if (!stage) return null;
  return (
    <span className={`badge whitespace-nowrap ${STAGE_PILL_CLS[stage] ?? 'badge-gray'} ${SIZE[size]} ${className}`.replace(/\s+/g, ' ').trim()}>
      {stageLabel(stage)}
    </span>
  );
}
